export const userInfo = {
  highSchool: {
    ceebCode: '12345',
    latitude: 38.8951,
    longitude: -77.0364,
  },
  userData: {
    username: 'samstudent',
    firstName: 'Sam',
    lastName: 'Student',
    birthDate: '1995-01-01',
    emailAddress: 'navqatest1@dev.naviance.com',
    weightedGpa: null,
    cumulativeGpa: 2.1,
    ferpaBlock: true,
    ethnicity: 'AS',
    gender: 'M',
    gradeLevel: 12,
    letterGrade: undefined,
    address: {
      studentId: 1000,
      streetAddress: '101 West Pine Street',
      streetAddress2: '404',
      city: 'Rolla',
      state: 'The other state',
      country: 'US',
      zip: process.env.REACT_APP_MOCK_GRAPHQL ? '01001' : '21001',
      latitude: 0,
      longitude: 0,
    },
    institution: '',
    defaultGpa: 4.0,
    age: 25,
    navigationItems: undefined,
    scattergramsSettings: undefined,
    recommendedEventCount: undefined,
    collegeVisitCount: undefined,
    userType: 'STUDENT',
    studentHighestScores: '',
    peerGpaMap: undefined,
    international: true,
    communityInfo: undefined,
    highSchoolId: '88881USPU',
    classYear: 2020,
    sat: 4,
    act: 3,
  },
};

export const collegesApplyingTo = [
  {
    id: 5511641,
    name: 'Regent University',
  },
  {
    id: 5511781,
    name: 'Cleveland Chiropractic College-Kansas City Campus',
  },
];

export const favoriteColleges = [
  {
    id: '5008049',
    name: "King's College",
  },
  {
    id: '5514741',
    name: 'Ave Maria University',
  },
  {
    id: '5502181',
    name: 'University of Maryland, Summer Sessions and Special Programs',
  },
];

export default function createLocalFcService() {
  return {
    getUserInfo: () => Promise.resolve(userInfo),
    clickTrackingEvents: (clickData) => {
      return Promise.resolve();
    },
  };
}
